module.exports = __webpack_public_path__ + "img/logo-light.b4974016.png";